// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/app_groups/:app_group_id/placements" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appGroupsAppGroupIdPlacements } from "./constants";
import type { GetAppGroupsAppGroupIdPlacementsParams, GetAppGroupsAppGroupIdPlacementsResult } from "./types";

export const getDataTableAppGroupsAppGroupIdPlacements = reactQueryTableFetcherAdapter(
  appGroupsAppGroupIdPlacements,
  (
    signal: AbortSignal,
    { appGroupId, query = {}, groupby, limit, start, sortdir, sortby }: GetAppGroupsAppGroupIdPlacementsParams
  ): Promise<GetAppGroupsAppGroupIdPlacementsResult> => {
    // Create the fetch options object conditionally
    const fetchOptions: Record<string, any> = {
      app_group_id: appGroupId,
      query: serializeQueryObjects(query),
      groupby,
      ...(limit !== undefined && { limit }), // Only include limit if it's defined
      ...(start !== undefined && { start }), // Only include start if it's defined
      ...(sortby && { sortby }), // Only include sortby if it's defined
      ...(sortdir && { sortdir }), // Only include sortdir if it's defined
    };

    return fetch(`/app_groups/${appGroupId}/placements`, "GET", fetchOptions, { signal });
  }
);
